import React, { useState, useEffect, useMemo, useCallback,useContext,useRef } from "react";
import { Button,Table, Tag, Space, Layout, message, Spin, Tooltip, DatePicker,Form,Select,Input } from "antd";
import {
  PauseCircleOutlined,
  PlayCircleOutlined,
  CloudDownloadOutlined,
  ReloadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import HeaderLayout from "../../layout/Header";
import NavBarLayout from "../../layout/NavBar";
import FooterLayout from "../../layout/Footer";
import { formatDateToYYYYMMDDHHMMSS, getShortDate } from "../../utils/Common";
import {
  downloadCallData,
  getCallData,
} from "../../services/instanceCallService";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { UserContext } from "../../components/call/UserContext";
import { isMobile } from "react-device-detect";
import { SaveOutlined , DeleteOutlined} from "@ant-design/icons";
import { postCallData ,putCallData ,deleteCallData } from "../../services/instanceCallService";
import jaJP from "antd/locale/ja_JP";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  horizontalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Papa from "papaparse";
import { saveAs } from "file-saver";


const { Content } = Layout;
const DraggableHeaderCell = ({ children, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: props["data-column-key"] });

  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : 0,
    background: isDragging ? "#e6f7ff" : undefined,
  };

  return (
    <th {...props} ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </th>
  );
};
const CallLogs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [logData, setLogData] = useState([]);
  const [isWaiting, setIsWaiting] = useState(false);
  const [audio, setAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState("");
  const [isDownloading, setIsDownloading] = useState("");
  const [currentAudioId, setCurrentAudioId] = useState(null);
  let [searchParams, setSearchParams] = useSearchParams();
  const date = searchParams.get("filter");
  const type = searchParams.get("type");
  const { author, setUser } = useContext(UserContext);
  const isAdmin = author?.is_admin;
  const is_enterprise = searchParams.get("is_enterprise");
  const [optTypeUpdateData, setUpdatedType] = useState([]);
  const [updatedStatus, setUpdatedStatus] = useState({});
  const [updatedCallerName, setUpdatedCallerName] = useState({});
  const [callerOptions, setCallerOptions] = useState([]);
  const [alertFormRows, setAlertFormRows] = useState({});
  const [alertTimes, setAlertTimes] = useState({});
  const { userInfo, author_id, setStatus, status } = useContext(UserContext);
  const textAreaRefs = useRef({});
  const [comments, setComments] = useState({});
  const curUserID = author_id ? author_id : 0;
  const sortStorageKey = "log_sort_state";

  const [sortState, setSortState] = useState(() => {
    const saved = localStorage.getItem(sortStorageKey);
    return saved ? JSON.parse(saved) : {};
  })
  let urlAPI = '/call-log/list?';

  const typeData = [
    { id: "0", name: "to C" },
    { id: "1", name: "to B" },
  ];
  
  const optTypeData = useMemo(() => {
    return typeData?.map(({ id, name }) => ({ value: id, label: name })) || [];
  }, [typeData]);
  
  useEffect(() => {
    fetchData();
  }, [searchParams]);
  useEffect(() => {
    if (isAdmin) {
      fetchCallerOptions();
    }
  }, [isAdmin]);
  const fetchCallerOptions = async () => {
    try {
      const result = await getCallData('/users');
      const options = [
        { value: null, label: "" },  // ← 先頭に追加
        ...result.data.map((user) => ({
          value: user.id,
          label: user.name,
        })),
      ];
      setCallerOptions(options);
    } catch (error) {
      messageApi.error('ユーザー一覧の取得に失敗しました');
    }
  };
  const fetchData = async () => {
    try {
      if (is_enterprise){
        urlAPI = `${urlAPI}&is_enterprise=${is_enterprise}`;
        // Get the user details from optSysUsers or optCurUsers
        const type = optTypeData.find((u) => u.value === is_enterprise) || [];

        if (type) {
          handleUpdateType(type.value, type.label);
        }
      }
      else{
        urlAPI = `${urlAPI}&is_enterprise=false`;
      }
      if (type === "date" && date) {
        setIsWaiting(true);
        const result = await getCallData(`${urlAPI}&date=${date}`);
        setLogData(result);
        setIsWaiting(false);
      } else {
        setIsWaiting(true);
        const result = await getCallData(`${urlAPI}`);
        setLogData(result);
        setIsWaiting(false);
      }

    } catch (error) {
      messageApi.success("Failed to delete project");
    } finally {
      setIsWaiting(false);
    }
  };

  const replayAudio = useCallback(() => {
    if (audio) {
      audio.currentTime = 0; // Reset the audio to the beginning
      audio.play();
      setIsPlaying("true");
    }
  }, [audio]);

  const togglePlayPause = useCallback(
    async (logId) => {
      setIsWaiting(true);
      if (currentAudioId && currentAudioId === logId) {
        if (audio) {
          if (audio.paused) {
            audio.play();
            setIsPlaying(logId);
          } else {
            audio.pause();
            setIsPlaying("");
          }
        }
        setIsWaiting(false);
        return;
      }
      if (audio) window.URL.revokeObjectURL(audio.src);

      try {
        const audioFile = await fetchAudio(logId);

        if (audioFile) {
          const url = window.URL.createObjectURL(audioFile);
          const newAudio = new Audio(url);
          newAudio.oncanplaythrough = () => {
            setAudio(newAudio);
            setIsPlaying(logId);
            setCurrentAudioId(logId);
            newAudio.play();
          };
          newAudio.onerror = (error) => {
            console.error("Error playing audio", error);
            setIsPlaying(false);
          };
          newAudio.onended = () => {
            setIsPlaying(false);
            window.URL.revokeObjectURL(url);
          };
        }
      } catch (error) {
        console.error("Error downloading or playing audio", error);
        setIsWaiting(false);
      } finally {
        setIsDownloading("");
        setIsWaiting(false);
      }
    },
    [audio, currentAudioId]
  );

  const fetchAudio = useCallback(async (logId) => {
    try {
      const audio = await downloadCallData(`/call-log/download/${logId}`);
      return audio;
    } catch (error) {
      console.error("Error fetching audio:", error);
      return null;
    }
  }, []);

  const downloadRecording = useCallback(
    async (logId) => {
      setIsDownloading(logId);
      const blob = await fetchAudio(logId);
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${logId}.mp3`; // set the file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // free memory
      }
      setIsDownloading("");
    },
    [fetchAudio]
  );

  const handleDateChange = (date, dataString) => {
    if (date) {
      if(is_enterprise){
        setSearchParams({ filter: date?.format("YYYY-MM-DD"), type: "date", is_enterprise: is_enterprise });
      } else {
        setSearchParams({ filter: date?.format("YYYY-MM-DD"), type: "date" });
      }
    } else {
      searchParams.delete("filter");
      searchParams.delete("type");
      setSearchParams(searchParams);
    }
  };

  const handleChangeType = (is_enterprise, dataString) => {
    if (is_enterprise) {
      setSearchParams({ is_enterprise: is_enterprise});
      // Get the user details from optSysUsers or optCurUsers
      const type = optTypeData.find((u) => u.value === is_enterprise) || optTypeData[0];

      if (type) {
        handleUpdateType(type.value, type.label);
      }
    } else {
      searchParams.delete("is_enterprise");
      searchParams.delete("filter");
      searchParams.delete("type");
      setSearchParams(searchParams);
    }
  };

  const handleUpdateType = (is_enterprise, name) => {
    // Add or update the user in updatedUser state
    setUpdatedType((prevState) => ({
      ...prevState,
      [is_enterprise]: { value: is_enterprise, label: name },
    }));
  };

  const statusList = {
    0: "不在",
    1: "興味なし",
    3: "即断り",
    4: "着信拒否",
    5: "再アクション",
    6: "面談アサイン",
    7: "イベントアサイン",
    8: "電話番号不備",
    // 9: "接触前",
    10: "追客中",
    11: "サービス停止",
    12: "サービス停止（メールOK）",
    13: "前日確認OK",
    14: "キャンセル",
    15: "日程変更",
  };
  const statusList2 = {
    16:"アポ獲得",
    17: "担当断り",
    18: "受付断り",
    19: "仮押さえ",
    20: "担当不在",
    21: "再架電"
  }
  const statusOptions = Object.entries(is_enterprise ? statusList2 : statusList).map(([value, label]) => ({
    value: String(value),
    label,
  }));
    const changeStatus = async (value, record) => {
    setUpdatedStatus((prev) => ({ ...prev, [record.id]: value }));
    await UpdateLogs(
      { author_id: curUserID, status: parseInt(value) },
      record.id
    );
    if (value == "21") {
      setAlertFormRows((prev) => ({ ...prev, [record.id]: true }));
    } else {
      setAlertFormRows((prev) => ({ ...prev, [record.id]: false }));
    }
  };
  const editAlertAt = async (record) => {
    const alertTime = alertTimes[record.id];
    if (!alertTime) return;
    try {
      if (record.alert_time) {
        // 既存あり → update
        await putCallData(`alerts/update/${record.id}/`, {
          alert_time: alertTime.format("YYYY-MM-DD HH:mm:ss"),
          is_read: false,
        });
      } else {
        // 新規 → store
        await postCallData(`alerts/${record.id}/`, {
          alert_time: alertTime.format("YYYY-MM-DD HH:mm:ss"),
        });
      }
      messageApi.success("アラートを設定しました");
    } catch (error) {
      messageApi.error("アラートの設定に失敗しました");
    }
  };
  const deleteAlertAt = async (record) => {
    try {
      await deleteCallData(`alerts/delete/${record.id}/`);
      // alertTimesをリセット
      setAlertTimes((prev) => {
        const next = { ...prev };
        delete next[record.id];
        return next;
      });
      messageApi.success("アラートを削除しました");
      await fetchData(); // record.alert_timeもリセットするためリロード
    } catch (error) {
      messageApi.error("アラートの削除に失敗しました");
    }
  };

  const editComment = async (record) => {
  const commentInput = textAreaRefs.current[record.id]
    ?.resizableTextArea?.textArea?.value;

  if (!commentInput) return;

  await UpdateLogs(
    { author_id: curUserID, comments: commentInput },
    record.id
  );
};
const changeCallerName = async (value, record) => {
  setUpdatedCallerName((prev) => ({ ...prev, [record.id]: value }));
  try{
    await UpdateLogs(
      { author_id: value },  
      record.id
    );
    await fetchData();
  }
  catch(error){
    messageApi.error("応対者の更新に失敗しました");
  }
};
  const UpdateLogs = async (params, id) => {
    setIsWaiting(true);
    try {
      await postCallData(`call-log/update/${id}/`, params);
      messageApi.success("更新しました");
    } catch (error) {
      messageApi.error("更新に失敗しました");
    } finally {
      setIsWaiting(false);
    }
  };
  const logsData = useMemo(() => {
    if (logData.data && Object.keys(logData.data).length > 0) {
      let logKey = 0;
      return logData.data.map((item) => ({
        key: logKey++,
        id: item.call_record_id,
        candidate: item.candidate_id,
        name: item.candidate_name,
        furigana: item.furigana,
        email: item.email,
        phone: item.candidate_phone,
        address: item.address,
        birthday: item.birthday ? getShortDate(item.birthday) : "",
        gender: item.gender,
        postal_code: item.postal_code,
        callee_number: item.callee_number,
        school_type: item.school_type,
        university_name: item.university_name,
        educational_stream: item.educational_stream,
        department: item.department,
        graduation_year: item.graduation_year,
        work_year: item.work_year,
        desired_industry: item.desired_industry,
        total_call: item.total_call,
        last_call: formatDateToYYYYMMDDHHMMSS(item.call_end_time),
        result_call: item.result,
        author_id: item.author_id,
        receipt_id: item.receipt_id,
        status: item.status,
        call_date: formatDateToYYYYMMDDHHMMSS(item.date_time),
        call_time: item.call_time,
        play_back: item.play_back,
        caller_name: item.caller_name,
        sys_caller_name: item.sys_caller_name,
        url_recording: item?.call_record_id ?? "",
        comments: item.comments,
        department_name: item.department_name,
        section_name: item.section_name,
        team_name: item.team_name,
        alert_time: item.alert_time,
      }));
    }
    return [];
  }, [logData]);
  const columns = useMemo(
    () => [
      { title: "姓名", dataIndex: "name", key: "name", width: 170 },
      { title: "誕生日", dataIndex: "birthday", key: "birthday", width: 120 },
      {
        title: "応対者",
        dataIndex: "caller_name",
        key: "caller_name",
        width: 260,
        render: (caller_name, record) => {
          if (isAdmin) {
            return (
              <Select
               showSearch                          
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase()) 
                  }
                value={updatedCallerName[record.id] ?? caller_name}
                options={callerOptions} 
                style={{ minWidth: "140px", width: "100%" }}
                popupMatchSelectWidth={false}            
                loading={isWaiting}
                onChange={(value) => changeCallerName(value, record)}
              />
            );
          }
          return <>{caller_name}</>;
        },
        filters: [
          { text: "なし", value: "__empty__" },
          ...new Set(logsData.map((item) => item.caller_name).filter(Boolean))
            ].map((name) => (typeof name === "string" ? { text: name, value: name } : name)),
        onFilter: (value, record) =>
          value === "__empty__"
            ? !record.caller_name  
            : record.caller_name === value
      },

      {
          title: '部署',
          dataIndex: 'department_name',
          key: 'department_name',
          width: 130,
          filters: [...new Set(logsData.map(item => item.department_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.department_name === value,
      },
      {
          title: '課',
          dataIndex: 'section_name',
          key: 'section_name',
          width: 130,
          filters: [...new Set(logsData.map(item => item.section_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.section_name === value,

      },
      {
          title: 'チーム',
          dataIndex: 'team_name',
          key: 'team_name',
          width: 100,
          filters: [...new Set(logsData.map(item => item.team_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.team_name === value,
      },
      {
        title: "Zoom 応対者",
        dataIndex: "sys_caller_name",
        key: "sys_caller_name",
        width: 120,
        render: (sys_caller_name) => <>{sys_caller_name}</>,
        filters: [
          { text: "なし", value: "__empty__" },  // ← 追加
          ...[...new Set(logsData.map(item => item.sys_caller_name).filter(Boolean))]
            .map(name => ({ text: name, value: name }))
        ],
        onFilter: (value, record) =>
          value === "__empty__"
            ? !record.sys_caller_name   // ← なし選択時は空のものだけ
            : record.sys_caller_name === value,
      },
      { title: "フリガナ", key: "furigana", dataIndex: "furigana", width: 170 },
      { title: "通話日", dataIndex: "call_date", key: "call_date", width: 120 },
      { title: "通話時間", dataIndex: "call_time", key: "call_time", width: 120,
          sorter: (a, b) => {
          const toSeconds = (t) => {
            if (!t) return 0;
            const parts = t.split(":").map(Number);
            return parts[0] * 3600 + parts[1] * 60 + (parts[2] || 0);
          };
          return toSeconds(a.call_time) - toSeconds(b.call_time);
        },  
      },
      {
        title: "再生",
        dataIndex: "url_recording",
        key: "url_recording",
        render: (url_recording, record) =>
          record.play_back === 1 ? (
            <Space>
              <Tooltip
                title="再生/一時停止"
                color="cyan"
                key={`play_pause_${record.key}`}
              >
                <a onClick={() => togglePlayPause(record.url_recording)}>
                  {isPlaying === record.url_recording ? (
                    <PauseCircleOutlined
                      style={{ color: "hotpink", fontSize: "20px" }}
                    />
                  ) : (
                    <PlayCircleOutlined
                      style={{ color: "#52c41a", fontSize: "20px" }}
                    />
                  )}
                </a>
              </Tooltip>
              <Tooltip
                title="最初から"
                color="cyan"
                key={`replay_${record.key}`}
              >
                <a onClick={() => replayAudio()}>
                  <ReloadOutlined
                    style={{
                      color: "#55f",
                      fontSize: "20px",
                      marginLeft: "10px",
                    }}
                  />
                </a>
              </Tooltip>
              <Tooltip
                title="ダウンロード"
                color="cyan"
                key={`down_${record.key}`}
              >
                {isDownloading === record.url_recording ? (
                  <LoadingOutlined
                    style={{
                      color: "blue",
                      fontSize: "20px",
                      marginLeft: "10px",
                    }}
                  />
                ) : (
                  <a onClick={() => downloadRecording(record.url_recording)}>
                    <CloudDownloadOutlined
                      style={{
                        color: "hotpink",
                        fontSize: "20px",
                        marginLeft: "10px",
                      }}
                    />
                  </a>
                )}
              </Tooltip>
            </Space>
          ) : null,
        width: 120,
      },
      {
        title: "結果の呼び出し",
        dataIndex: "result_call",
        key: "result_call",
        width: 130,
          filters: [...new Set(logsData.map(item => item.result_call).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.result_call === value,
      },
      {
        title: "ステータス",
        dataIndex: "status",
        key: "status",
        render: (status, record) => {
          const canEdit = isAdmin || record.author_id === curUserID;
          return (
            <>
              <Select
                value={updatedStatus[record.id] || record.status?.toString()}
                onChange={(value) => changeStatus(value, record)}
                options={statusOptions}
                loading={isWaiting}
                style={{ width: "215px" }}
                disabled={!canEdit}  // ← 編集不可
              />
              <div style={{ display: "flex", alignItems: "center", marginTop: "10px" , gap: "5px"}}>
                {canEdit && (alertFormRows[record.id] || record.status == 21 || updatedStatus[record.id] == "21") && (
                  <>
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder="アラート日時を選択"
                    style={{ marginTop: "5px" }}
                    value={alertTimes[record.id] ?? (record.alert_time ? dayjs(record.alert_time) : null)}
                    onChange={(val) => setAlertTimes((prev) => ({ ...prev, [record.id]: val }))}
                    onOk={(val) => setAlertTimes((prev) => ({ ...prev, [record.id]: val }))}
                    onCalendarChange={(val) => {
                        if (val) setAlertTimes((prev) => ({ ...prev, [record.id]: val }));
                    }}
                  />
                  <Tooltip title="保存する">
                      <Button
                        onClick={() => editAlertAt(record)}
                        icon={<SaveOutlined />}
                        loading={isWaiting}
                      />
                    </Tooltip>
                    <Tooltip title="削除する">
                      <Button
                        onClick={() => deleteAlertAt(record)}
                        icon={<DeleteOutlined />}
                        loading={isWaiting}
                      />
                    </Tooltip>
                  </>
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center", marginTop: "10px" , gap: "5px"}}>
                {canEdit ? (
                  <>
                    <Input.TextArea
                      ref={(el) => (textAreaRefs.current[record.id] = el)}
                      defaultValue={record.comments || ""}
                      rows={1}
                      style={{ width: "215px" }}
                      maxLength={20}
                      showCount
                    />
                    <Tooltip title="保存する">
                      <Button
                        onClick={() => editComment(record)}
                        icon={<SaveOutlined />}
                        loading={isWaiting}
                      />
                    </Tooltip>
                  </>
                ) : (
                  // 閲覧のみ
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {record.comments || ""}
                  </div>
                )}
              </div>
            </>
          );
        },
        filters: [...new Set(logsData.map(item => item.status).filter(v => v !== null && v !== undefined))]
          .map(statusValue => ({
            text: (is_enterprise ? statusList2 : statusList)[statusValue] ?? statusValue,
            value: String(statusValue),
          })),
        onFilter: (value, record) => String(record.status) === value,
        width: 250,
      },
      {
        title: "性別",
        dataIndex: "gender",
        key: "gender",
        width: 120,
        render: (gender) => <>{gender}</>,
      },
      { title: "電話番号", dataIndex: "phone", key: "phone", width: 120 },
      { title: "住所", dataIndex: "address", key: "address", width: 120 },
      {
        title: "郵便番号",
        dataIndex: "postal_code",
        key: "postal_code",
        width: 120,
      },
      ...(is_enterprise
        ? [] // Empty array when is_enterprise is true, no extra columns
        : [
            {
              title: "大学名",
              dataIndex: "university_name",
              key: "university_name",
              width: 120,
            },
            {
              title: "学校種類",
              dataIndex: "school_type",
              key: "school_type",
              width: 120,
            },
            {
              title: "学部学科",
              dataIndex: "department",
              key: "department",
              width: 120,
            },
            {
              title: "文理",
              dataIndex: "educational_stream",
              key: "educational_stream",
              width: 130,
            },
            {
              title: "卒業年",
              dataIndex: "graduation_year",
              key: "graduation_year",
              width: 120,
            },
            {
              title: "就職希望年度",
              dataIndex: "work_year",
              key: "work_year",
              width: 120,
            },
            {
              title: "志望業界",
              dataIndex: "desired_industry",
              key: "desired_industry",
              width: 120,
            },
          ]),
      {
        title: "最終架電日",
        dataIndex: "last_call",
        key: "last_call",
        width: 145,
      },
    ],
    [isPlaying, isDownloading, togglePlayPause, replayAudio, downloadRecording, is_enterprise, updatedStatus, changeStatus, logsData, updatedCallerName, callerOptions, changeCallerName]  
  );

   const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // 8px動かしたらドラッグ開始
      },
    })
  );
  const storageKey = "calllog_column_order";

  const [columnOrder, setColumnOrder] = useState(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {
        return columns.map((col) => col.key);
      }
    }
    return columns.map((col) => col.key);
  });
   const handleDragEnd = ({ active, over }) => {
      if (!over || active.id === over.id) return;
      setColumnOrder((prev) => {
        const oldIndex = prev.indexOf(active.id);
        const newIndex = prev.indexOf(over.id);
        const next = arrayMove(prev, oldIndex, newIndex);
        localStorage.setItem(storageKey, JSON.stringify(next));
        return next;
      });
};
const handleTableChange = (pagination, filters, sorter) => {
  const newSortState = {
    columnKey: sorter.columnKey,
    order: sorter.order,
  };

  setSortState(newSortState);
  localStorage.setItem(sortStorageKey, JSON.stringify(newSortState));
};
    const orderedColumns = useMemo(
    () =>
      columnOrder
        .map((key) => columns.find((col) => col.key === key))
        .filter(Boolean)
        .map((col) => ({
          ...col,
          onHeaderCell: () => ({ "data-column-key": col.key }), // ← 追加
        })),
    [columnOrder, columns]
);
const columnsWithSort = useMemo(() => {
  return orderedColumns.map((col) => ({
    ...col,
    sortOrder:
      sortState.columnKey === col.key ? sortState.order : null,
  }));
}, [orderedColumns, sortState]);
  const exportCSVData = () => {
    // フィルター後のデータがあればそれを使い、無ければ全データを使う

    if (logsData && logsData.length > 0) {
      const csvDataExp = logsData.map((row) => ({
        名前: row.name,
        部署: row.department_name,
        課: row.section_name,
        チーム: row.team_name,
        応対者: row.caller_name,
        Zoom応対者: row.sys_caller_name,
        フリガナ: row.furigana,
        通話日: row.call_date,
        通話時間: row.call_time,
        結果の呼び出し: row.result_call,
        ステータス: (is_enterprise ? statusList2 : statusList)[row.status] ?? row.status,
        コメント: row.comments,
        性別: row.gender,
        電話番号: row.phone,
        住所: row.address,
        郵便番号: row.postal_code,
        ...(is_enterprise
          ? {} // Empty object when is_enterprise is true, no extra columns
          : {
              大学名: row.university_name,
              学校種類: row.school_type,
              学部学科: row.department,
              文理: row.educational_stream,
              卒業年: row.graduation_year,
              就職希望年度: row.work_year,
              志望業界: row.desired_industry,
          }),
       最終架電日: row.last_call,

      }));

      const now = dayjs();
      const formattedDate = now.format("YYYY-MM-DD");
      const bom = "\uFEFF";
      const csv = bom + Papa.unparse(csvDataExp, { header: true });
      const blob = new Blob([csv], { type: "text/csv;charset=ansi" });
      saveAs(blob, date == null ? formattedDate : date + "-Report.csv");
    } else {
      messageApi.error("Error fetching candidates");
      setIsWaiting(false);
    }
  };
    
  return (
    <Layout>
      <HeaderLayout />
      {contextHolder}
      <Layout>
        <NavBarLayout />
          <Content style={{ padding: "10px" ,...(isMobile && { marginTop: "64px" })}}>

          <div style={{ minHeight: 780 }}>
            {isLoading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Spin size="large" /> {/* Show loading spinner */}
                <p>Loading...</p> {/* Optional: Show a loading message */}
              </div>
            ) : (
              <>
               <Space>
                <h1>{is_enterprise ? ( <span>to B</span> ) : (<span>to C</span>) } コールログ</h1>
                {/* <Select
                    showSearch
                    disabled={false}
                    placeholder="ロールを選択してください"
                    options={optTypeData}
                    onChange={(value) => handleChangeType(value)}
                    value={optTypeUpdateData[is_enterprise]?.value || []}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                /> */}
                <DatePicker
                    style={{ width: "100%" }}
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    placeholder="日にちを選択"
                    value={
                      type === "date" && date ? dayjs(date, "YYYY-MM-DD") : null
                    }
                    locale={jaJP.DatePicker}
                />
                <Button
                      type="dashed"
                      onClick={() => {
                        localStorage.removeItem(storageKey);
                        setColumnOrder(columns.map((col) => col.key));
                        localStorage.removeItem("log_sort_state");
                      }}
                    >
                      テーブルリセット
                    </Button>
                    <Button
                      type="dashed"
                      danger
                      loading={isWaiting}
                      onClick={exportCSVData}
                    >
                      CSV出力
                    </Button>
                </Space>
                {/* <Table
                  virtual
                  columns={columns}
                  dataSource={logsData}
                  rowKey="key"
                  pagination={false}
                  scroll={{ y: 690, x: 580 }}
                  loading={isWaiting}
                /> */}
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={columnOrder}
                    strategy={horizontalListSortingStrategy}
                  >
                    <Table
                      virtual
                      columns={columnsWithSort}
                      dataSource={logsData}
                      onChange={handleTableChange}
                      rowKey="key"
                      pagination={false}
                      scroll={{ y: 690, x: 580 }}
                      loading={isWaiting}
                      components={{
                        header: {
                          cell: DraggableHeaderCell,
                        },
                      }}
                    />
                  </SortableContext>
                </DndContext>
              </>
            )}
          </div>
          <FooterLayout />
        </Content>
      </Layout>
    </Layout>
  );
};

export default CallLogs;
